import MainPointInsights from './components/MainPointInsights.vue'
import MainPointOutcomeChart from './components/MainPointOutcomeChart.vue'
import IndexStatusCellField from './fields/Index/StatusCellField.vue'
import IndexLifecycleStepperField from './fields/Index/LifecycleStepperField.vue'
import IndexPriceDistanceMeterField from './fields/Index/PriceDistanceMeterField.vue'

/**
 * Register coins-module Nova Vue cards and fields.
 *
 * @param {import('vue').App} app
 */
const coinsModuleSetup = (app) => {
  app.component('main-point-insights', MainPointInsights)
  app.component('main-point-outcome-chart', MainPointOutcomeChart)
  app.component('index-status-cell-field', IndexStatusCellField)
  app.component('index-lifecycle-stepper-field', IndexLifecycleStepperField)
  app.component('index-price-distance-meter-field', IndexPriceDistanceMeterField)
}

export { coinsModuleSetup }
